import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-enterprise-features-section',
  imports: [TuiIcon, SectionHeaderComponent],
  templateUrl: './enterprise-features-section.component.html',
  styleUrl: './enterprise-features-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseFeaturesSectionComponent {}
